import {
  watchSubmitSignupStep,
  watchUserAuth,
  watchUserLogout,
  watchSetNotificationRead,
  watchGetProfileSettingsInfo,
  watchGetNotifications,
  watchUpdateProfileSettingsInfo,
  watchGetUserInfo,
  watchResendByEmail,
} from 'store/user/saga';

export default [
  watchSubmitSignupStep,
  watchUserAuth,
  watchUserLogout,
  watchSetNotificationRead,
  watchGetProfileSettingsInfo,
  watchGetNotifications,
  watchUpdateProfileSettingsInfo,
  watchGetUserInfo,
  watchResendByEmail,
];
